import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table';

import bannerLeft from '@imgs/block/banner_left.png';
import bannerRight from '@imgs/block/banner_right_pic.png';
import blockIcon1 from '@imgs/block/block_icon1.png';
import blockIcon2 from '@imgs/block/block_icon2.png';
import blockIcon3 from '@imgs/block/block_icon3.png';
import blockIcon4 from '@imgs/block/block_icon4.png';
import blockIcon5 from '@imgs/block/block_icon5.png';
import backgroundRectangle from '@imgs/block/bg_rectangle.png';
import {Title} from "@components/ui/Title";
import {GetBlockList, GetStatistics} from '@src/utils/apis/explorer';
import {BlockItem, StatisticsInfo} from '@src/models/explorer';

export default function Block() {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [recordCount, setRecordCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState<StatisticsInfo | null>(null);
  const [list, setList] = useState<BlockItem[]>([]);

  const getList = useCallback(() => {
    setIsLoading(true);
    GetBlockList({
      size: pageSize,
      current: pageIndex,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.data && res.data.list) {
          // 遍历数据，添加到list中
          const list = res.data.list.map((item: BlockItem) => {
            return {
              ...item,
              key: item.blockHash,
            };
          });
          setList(list);
          setRecordCount(res.data.total);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [pageIndex, pageSize]);

  useEffect(() => {
    // 跳到页面顶部
    window.scrollTo(0, 0);
    GetStatistics({}).then((res) => {
      if (res.data) {
        setDetail(res.data);
      }
    });
  }, []);

  useEffect(() => {
    getList();
  }, [pageIndex, pageSize]);


  const columns: ColumnsType<any> = [
    {
      key: 'blockHeight',
      dataIndex: 'blockHeight',
      title: '区块高度',
      width: 150,
      align: 'center',
    },
    {
      key: 'blockHash',
      dataIndex: 'blockHash',
      title: '区块Hash',
      align:'center',
      // ellipsis: true,
    },
    {
      key: 'txCount',
      dataIndex: 'txCount',
      title: '交易数',
      width: 150,
      align:'center',
    },
    {
      key: 'proposalNodeId',
      dataIndex: 'proposalNodeId',
      title: '出块节点',
      align:'center',
      width:240,
      // ellipsis: true,
    },
    {
      key: 'date',
      dataIndex: 'date',
      title: '区块生成时间',
      width: 240,
      align:'center',
    },
];

  return (
      <div className={styles.block}>
        <div className={styles.banner}>
          <img src={backgroundRectangle} alt="" className={styles.backgroundRectangle}/>
          <div style={{'marginRight':'115px'}}>
            <img src={bannerLeft} alt=""/>
          </div>
          <div>
            <img src={bannerRight} alt=""/>
          </div>
        </div>
        <div className={styles.summary}>
          <div className={styles.box}>
            <div className={styles.item}>
              <div>
                <img src={blockIcon1} alt=""/>
              </div>
              <div className={styles.value}>{detail?.blockHeight}</div>
              <div className={styles.label}>区块高度</div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.item}>
              <div>
                <img src={blockIcon2} alt=""/>
              </div>
              <div className={styles.value}>{detail?.contractNum}</div>
              <div className={styles.label}>累计合约数</div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.item}>
              <div>
                <img src={blockIcon3} alt=""/>
              </div>
              <div className={styles.value}>{detail?.nodeNum}</div>
              <div className={styles.label}>节点数</div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.item}>
              <div>
                <img src={blockIcon4} alt=""/>
              </div>
              <div className={styles.value}>{detail?.transactionNum}</div>
              <div className={styles.label}>累计存证</div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.item}>
              <div>
                <img src={blockIcon5} alt=""/>
              </div>
              <div className={styles.value}>{detail?.orgNum}</div>
              <div className={styles.label}>组织数</div>
            </div>
          </div>
        </div>
        <div className={styles.blockList}>
          <Title text={'最新出块'} />
          <Table
            style={{
              marginTop: 30,
            }}
            className={styles.table}
            dataSource={list}
            columns={columns}
            loading={isLoading}
            pagination={{
              current: pageIndex,
              pageSize: pageSize,
              pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
              total: recordCount,
              showQuickJumper: true,
              onChange: (page, pageSize) => {
                setPageIndex(page);
                setPageSize(pageSize);
              },
            }}
          />

        </div>
      </div>
  );
}
